import Colors from "../../core/Colors";
import { floodFill } from "../helpers";
import { ComponentF } from "../ui";
import { handleKeyOnClick } from "./keyOnClick";

export const ButtonComp: ComponentF<{
  title: string;
  keys: string | string[];
  showKey: boolean;
  onClick: () => void;
}> = (C, props) => {
  const [state, setState] = C.useState({ hover: false });
  floodFill(
    C.display,
    C.bounds,
    state.hover ? Colors.OFF_BLACK_2 : Colors.OFF_BLACK
  );
  let x = C.bounds.x;
  if (props.showKey) {
    C.display.drawOver(
      x,
      C.bounds.y,
      Array.isArray(props.keys) ? props.keys[0] : props.keys,
      Colors.RED,
      null
    );
    x += 2;
  }

  for (let i = 0; i < props.title.length; i++) {
    C.display.drawOver(
      i + x,
      C.bounds.y,
      props.title[i],
      Colors.EGGSHELL,
      null
    );
  }
  C.handlers.hover = () => {
    setState({ hover: true });
  };
  C.handlers.out = () => {
    setState({ hover: false });
  };

  C.handlers.press = () => {
    props.onClick();
  };
  handleKeyOnClick(C, props);
};
